/* eslint-disable camelcase */
const STARS_COUNT = 5;
const REQUEST_TIMEOUT = 30000;
const DEFAULT_LANG = "cs";
const FIRM_SOURCE = "firm";
const RULES_LINKS_FIRM = {
    cs: "https://napoveda.firmy.cz/obecna-pravidla-pro-profily/pravidla-pro-recenze/",
    sk: "https://napoveda.firmy.cz/obecna-pravidla-pro-profily/pravidla-pro-recenze/",
    en: "https://napoveda.firmy.cz/evaluation-of-firms/",
};
const RULES_LINKS_NOFIRM = {
    cs: "https://help.mapy.com/cs/hodnoceni/pravidla/",
    sk: "https://help.mapy.com/sk/hodnotenie/pravidla/",
    en: "https://help.mapy.com/en/ratings/rules/",
    de: "https://help.mapy.com/de/bewertung/richtlinien/",
    pl: "https://help.mapy.com/pl/oceny/zasady-dodawania-ocen/",
    it: "https://help.mapy.com/it/valutazione/linee-guida/",
};
const FIRM_FOOTER_LINKS = {
    RULES: "https://napoveda.firmy.cz/firemni-profil/recenze",
    PERSONAL_RULES: "https://napoveda.firmy.cz/obecna-pravidla-pro-profily/zpracovani-osobnich-udaju/",
    LICENCE: {
        cs: "https://licence.mapy.cz/?doc=mapy_lu&lang=cs",
        en: "https://licence.mapy.cz/?doc=mapy_lu&lang=en",
    },
};
const DIALOG_PAGES = {
    // page-a
    ALTERNATIVES: "PAGE-ALTERNATIVES",
    // page-ss
    STARS_STRUCTURED: "PAGE-STARS-STRUCTURED",
    // page-tp
    TEXT_PHOTO: "PAGE-TEXT-PHOTO",
    // page-edit
    EDIT: "PAGE-EDIT",
    THANK_YOU: "PAGE-THANK-YOU",
    REVIEW_REMOVE: "PAGE-REVIEW-REMOVE",
    FINAL: "PAGE-FINAL",
    STICKERS: "PAGE-STICKERS",
    EMPTY: "EMPTY",
};
// 3000 = 3s
const LAST_DIALOG_TO = 3000;
const MIME_TYPES = [
    "image/jpeg",
    "image/pjpeg",
    "image/png",
];
const DEFAULT_TYPE_ID = 290;
const EMOJI_POS_VALUE = 100;
const EMOJI_NEG_VALUE = 0;
const STRUCTURED_MEDIAN = 4;
const MAX_PHOTOS_PER_LINE = 4;
const MAX_TEXT_LENGTH = 2500;
const LAST_TEXT_LENGTH = 100;
const MAX_RESPONSIVE_WIDTH = 500;
const STARS_SIZE = {
    normal: 48,
    responsive: 40,
};

export { DEFAULT_LANG as D, EMOJI_POS_VALUE as E, FIRM_SOURCE as F, LAST_DIALOG_TO as L, MAX_RESPONSIVE_WIDTH as M, RULES_LINKS_FIRM as R, STARS_COUNT as S, DEFAULT_TYPE_ID as a, EMOJI_NEG_VALUE as b, RULES_LINKS_NOFIRM as c, DIALOG_PAGES as d, STRUCTURED_MEDIAN as e, REQUEST_TIMEOUT as f, FIRM_FOOTER_LINKS as g, MAX_TEXT_LENGTH as h, LAST_TEXT_LENGTH as i, STARS_SIZE as j, MAX_PHOTOS_PER_LINE as k, MIME_TYPES as l };

//# sourceMappingURL=const.js.map